import { useState } from 'react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Trash2, AlertTriangle } from 'lucide-react';
import api from '../lib/api';
import { toast } from 'sonner';
import { ImportDialog } from './ImportDialog';

// Import tervalidasi (routes/imports.py) per koleksi. Koleksi tanpa padanan
// (PO, invoice, bank) sengaja tanpa tombol import: memasukkan baris mentah
// ke data transaksi melewati semua validasi dan alur status.
const IMPORT_TYPE = {
  internal_payment_requests: ['ipr', 'Internal Payment Request'],
  operational_payment_requests: ['opr', 'Operasional Payment Request'],
  recipients: ['recipients', 'Data Penerima'],
  suppliers: ['suppliers', 'Supplier'],
  companies: ['companies', 'Perusahaan'],
};


export function AdminBulkActions({ collectionType, collectionLabel, onRefresh }) {
  const [showBulkDelete, setShowBulkDelete] = useState(false);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const handleBulkDelete = async () => {
    if (confirmText !== 'HAPUS SEMUA') return;
    setBulkDeleteLoading(true);
    try {
      const res = await api.delete(`/admin/bulk-delete/${collectionType}`, {
        data: { reason: `Hapus semua ${collectionLabel}` }
      });
      toast.success(res.data.message);
      setShowBulkDelete(false);
      setConfirmText('');
      if (onRefresh) onRefresh();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal menghapus data');
    } finally {
      setBulkDeleteLoading(false);
    }
  };

  return (
    <>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="outline"
          className="border-red-300 text-red-600 hover:bg-red-50"
          onClick={() => setShowBulkDelete(true)}
          data-testid={`bulk-delete-${collectionType}`}
        >
          <Trash2 className="h-4 w-4 mr-1" />
          Hapus Semua
        </Button>
        {IMPORT_TYPE[collectionType] && (
          <ImportDialog
            type={IMPORT_TYPE[collectionType][0]}
            title={IMPORT_TYPE[collectionType][1]}
            label="Import Excel"
            className="border-emerald-300 text-emerald-600 hover:bg-emerald-50"
            onDone={onRefresh}
            testId={`import-${collectionType}`}
          />
        )}
      </div>

      <Dialog open={showBulkDelete} onOpenChange={setShowBulkDelete}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <AlertTriangle className="h-5 w-5" />
              Hapus Semua {collectionLabel}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <p className="text-sm text-slate-600">
              Tindakan ini akan menghapus <strong>SEMUA</strong> data {collectionLabel} secara permanen dan dicatat di log penghapusan.
            </p>
            <div className="space-y-2">
              <Label className="text-red-600">Ketik <strong>HAPUS SEMUA</strong> untuk konfirmasi:</Label>
              <Input
                value={confirmText}
                onChange={(e) => setConfirmText(e.target.value)}
                placeholder="HAPUS SEMUA"
                data-testid={`bulk-delete-confirm-${collectionType}`}
              />
            </div>
            <Button
              onClick={handleBulkDelete}
              className="w-full bg-red-600 hover:bg-red-700"
              disabled={confirmText !== 'HAPUS SEMUA' || bulkDeleteLoading}
              data-testid={`bulk-delete-submit-${collectionType}`}
            >
              {bulkDeleteLoading ? 'Menghapus...' : 'Hapus Semua Data'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}



